import { AxiosInstance } from 'axios';
import React, { createContext, useEffect, useRef, useState } from 'react';

export interface IContext {
    instanceAxios?: AxiosInstance;
    pathApiVersion?: string; // api/v1
    // collectionList: {[key: string]: any},
    // updater: string[]
}

export const SmxContext = createContext<IContext | null>(null);

interface IConnectionProvider {
    children: React.ReactNode;
    initInstanceAxios: AxiosInstance;
    initPathApiVersion: string; // api/v1
}

//todo component is deprecated
const ConnectionProvider: React.FC<IConnectionProvider> = ({ initInstanceAxios, initPathApiVersion, children }) => {
    const refInstance = useRef(initInstanceAxios);
    const [pathApiVersion, setPathApiVersion] = useState<string>();

    useEffect(() => {
        refInstance.current = initInstanceAxios;
    }, [initInstanceAxios]);

    useEffect(() => {
        setPathApiVersion(initPathApiVersion);
    }, [initPathApiVersion]);

    return (
        <SmxContext.Provider value={{ instanceAxios: refInstance.current, pathApiVersion }}>
            {children}
        </SmxContext.Provider>
    );
};

export default ConnectionProvider;
